import React from "react";
import logo1 from "../Asset/logo1.png";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import $ from "jquery";
import { connect } from "react-redux";
import { withRouter, NavLink, Link } from "react-router-dom";
import { IoIosMenu } from "react-icons/io";
import { UserAgentApplication } from "msal";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import "antd/dist/antd.css";
import { Menu, Button } from "antd";
import Role from "../helpers/role";
import AuthService from "../Authentication/AuthService";
import {
  getApprovalCount,
  getPendingShipCount,
} from "../Actions/ApproverScreenAPI";
import axios from "axios";
import API from "../helpers/api";
import { lang } from "glamor";
import i18n from "./DropdownLanguage/i18n";
import DropdownLanguage from "../components/DropdownLanguage/DropdownLanguage";



const { SubMenu } = Menu;
let currentuser = JSON.parse(localStorage.getItem("currentUser"));
class MMTopPane extends React.Component {
  constructor() {
    super();
    this.authService = new AuthService();
    this.state = {
      show: false,
      currentUser: "",
      isGrandAdmin: false,
      isApprover: false,
      BudgetPath: "",
      selectedLanguage: 'en'
    };
  }

  changeLanguage = (e) => {
    i18n.changeLanguage(e.target.value);
    this.setState({
      selectedLanguage: e.target.value
    });
  }

  componentDidMount() {
    this.resize();
    var _this = this;
    const { history, dispatch, match } = this.props;
    this.setState({
      BudgetPath: match.path,
    });
    $(document).ready(function () {
      $('.Admin-dropdown-click').click(function () {
        const newLocal = '.admin-dropdown';
        $(newLocal).toggleClass('show');
      });
    });
    $(document).ready(function () {
      $('.masterdata-click').click(function () {
        const newLocal = '.masterdata-dropdown';
        $(newLocal).toggleClass('show');
      });
    });
    $(document).ready(function () {
      $('.Approver-click').click(function () {
        const newLocal = '.approver-dropdown';
        $(newLocal).toggleClass('show');
      });
    });
    $(document).on("click", function (event) {
      var $trigger = $(".Admin-dropdown-click");
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".admin-dropdown").removeClass('show');
      }
      var $trigger1 = $(".masterdata-click");
      if ($trigger1 !== event.target && !$trigger1.has(event.target).length) {
        $(".masterdata-dropdown").removeClass('show');
      }
      var $trigger2 = $(".Approver-click");
      if ($trigger2 !== event.target && !$trigger2.has(event.target).length) {
        $(".approver-dropdown").removeClass('show');
      }

    });
    let user = localStorage.getItem("UserRoles");
    if (user == Role.approver) {
      dispatch(getApprovalCount(currentuser));
      dispatch(getPendingShipCount(currentuser));
    }
    if (user == Role.mmpl) {
      dispatch(getPendingShipCount(currentuser));
    }
    _this.authService.getCurrentUserDetails().then(function (user) {
      _this.setState({ currentUser: user });
      _this.props.dispatch({ type: "UserRole", data: user.role });
      _this.props.dispatch({
        type: "AuthenticatedUserInformation",
        data: user,
      });

      // _this.getuserDetails(user.name);
    });
    /*  var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    );
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = this.googleTranslateElementInit;
    $(".goog-te-banner").css({ display: "none" }); */
  }

  googleTranslateElementInit() {
    new window.google.translate.TranslateElement(
      {
        includedLanguages: "ja,ko,en",
      },
      "google_translate_element"
    );

    $(".goog-te-combo").addClass("form-control");
    var $googleDiv = $("#google_translate_element .skiptranslate");
    var $googleDivChild = $("#google_translate_element .skiptranslate div");
    $googleDivChild.next().remove();
    $googleDiv
      .contents()
      .filter(function () {
        return this.nodeType === 3 && $.trim(this.nodeValue) !== "";
      })
      .remove();
    $(".goog-te-combo").on("change", function () {
      var language = $("select.goog-te-combo option:selected").val();
      localStorage.setItem("SelectedLanguage", language);
    });
    setTimeout(() => {
      this.changeLangToSV();
    }, 2000);
  }

  changeLangToSV() {
    let ele = document.querySelector("#google_translate_element select");
    ele.selectedIndex = 1;
    ele.dispatchEvent(new Event("change"));
  }
  resize() {
    const { dispatch } = this.props;
    setTimeout(() => {
      var Lang = $("#google_translate_element > div>div>select").val();
      console.log("selected Language", Lang);
      localStorage.setItem("SelectedLanguage", Lang);
      dispatch({
        type: "SelectedLanguage",
        data: Lang,
      });
    }, 9000);
  }

  // getuserDetails(mailId) {
  //   let url = `${API.getUser}?Mail=${mailId}`;
  //   axios.get(url)
  //     .then((response) => {
  //       if (response?.data?.data) {
  //         let id = response?.data?.data[0].userId;
  //         let url1 = `${API.getUserDetail}?userid=${id}`;
  //         axios.get(url1)
  //           .then((response1) => {
  //             if (response1 && response1.data) {
  //               console.log("response1.data", response1.data);
  //               this.setState({ isGrandAdmin: response1.data?.grandAdminAccess });
  //             }
  //           })
  //           .catch((error) => {
  //           })
  //       }
  //     })
  //     .catch((error) => {
  //     })
  // }

  render() {
    const {
      t,
      userDetail,
      ShowShipDetails,
      history,
      ApprovalCount,
      PendingShipCount,
    } = this.props;
    const { currentUser } = this.state;
    let user = localStorage.getItem("UserRoles");
    return (
      <div className="app-header">
        {/* <div className="collapse show label">
          <span>System </span>
          <span>| </span>
          <span>Account</span>
        </div> */}
        <div className="site-header-inner">
          <div
            className="row wid100 ml-0"
            style={{ maxWidth: "100%", flex: "0 0 100%" }}
          >
            <div className="col-sm6 m-auto col-sm-2 p0">
              <a
                href="#"
                onClick={() => {
                  history.push("/");
                }}
              >
                <img className="logo-image" src={logo1}></img>
              </a>
            </div>
            <div
              className="col-sm6 m-auto menu-parent responsive-flex"
              data-toggle="collapse"
              data-target="#main_nav"
              // style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <div className="col-sm6 m-auto menu-parent">
                <select
                  id="Multi-language"
                  className="form-control text-left space"
                  onChange={this.changeLanguage}
                  style={{ marginTop: '0.6rem', marginBottom: '0.6rem', padding: '1px' }}
                  value={this.state.selectedLanguage}
                >
                  {" "}
                  <option value="en">English</option>
                  <option value="arab">Arabic</option>
                  <option value="zh">Chinese</option>
                  <option value="fr">French</option>
                  <option value="in">Indonesian</option>
                  <option value="ja">Japanese</option>
                  <option value="ko">Korean</option>
                  <option value="ma">Malay</option>
                  <option value="ru">Russian</option>
                  <option value="es">Spanish</option>
                </select>
              </div>
              <IoIosMenu
                onClick={
                  (e) => this.setState({ show: !this.state.show })}
                style={{ width: "40px", height: "40px", float: "right", margin: '0px' }}
                className="do menu"
              />
            </div>
            {/* <div className="col-1"></div> */}
            <nav className="navbar-expand-lg h-menu m-auto col-sm-5 text-center">
              <div className="h-menu navbar-collapse">
                <ul className="navbar-nav m-auto">
                  {/* {ShowShipDetails ? (
                    <li className="nav-item nav-menu-item">
                      <a className="nav-link discover navstyle" href="#">Ship Equipment Status </a>
                    </li>
                  ) : null} */}

                  {user == Role.staff ? (
                    <li className="nav-item nav-menu-item">
                      <a
                        className="nav-link discover navstyle"
                        onClick={(e) => this.StaffDashboardNavigation(e)}
                        href="/Home/ShipDetails"
                      >
                        {t("TopPaneContent.Home")}
                      </a>
                    </li>
                  ) : null}

                  {user == Role.client ? (
                    <li className="nav-item nav-menu-item">
                      <a
                        className="nav-link discover navstyle"
                        onClick={(e) => this.ClientDashboardNavigation(e)}
                        href="/Home/ClientDashboard"
                      >
                        {t("TopPaneContent.Home")}
                      </a>
                    </li>
                  ) : null}

                  {window.location.pathname.indexOf(
                    "/Home/BudgetListView/:id"
                  ) !== -1 ? null : (
                    <>
                      {user == Role.mmpl || user == Role.mmpladmin ? (
                        <li className="nav-item nav-menu-item">
                          <a
                            className="nav-link discover navstyle"
                            onClick={(e) => this.MMPLDashboardNavigation(e)}
                            href="/Home/MMPLDashboard"
                          >
                            {/*  Home */}
                            {t("TopPaneContent.Home")}
                          </a>
                        </li>
                      ) : null}
                    </>
                  )}
                  {window.location.href.indexOf("/Home/BudgetListView/:id") !==
                    -1 ? null : (
                    <>
                      {user == Role.mmpl || user == Role.mmpladmin ? (
                        <li className="nav-item nav-menu-item">
                          <a
                            className="nav-link discover navstyle"
                            onClick={(e) => this.MMPLServiceUpdat(e)}
                            href="/Home/ServiceUpdate"
                          >
                            {/* Service Update */}
                            {t("TopPaneContent.ServiceUpdate")}
                          </a>
                        </li>
                      ) : null}
                    </>
                  )}
                  {user == Role.approver ? (
                    <li className="nav-item nav-menu-item">
                      <a
                        onClick={(e) => this.ApproverDashboardNavigation(e)}
                        className="nav-link discover navstyle"
                        href="/Home/ApproverDashboard"
                      >
                        {t("TopPaneContent.Home")}
                      </a>
                    </li>
                  ) : null}
                  {/*    {user == Role.approver ? (
                    <li className="nav-item nav-menu-item mr-4">
                      <a
                        onClick={(e) => this.PendingShipNavigation(e)}
                        className="nav-link discover navstyle"
                        href="/Home/PendingShip"
                      >
                        {t("TopPaneContent.PendingShips")}{" "}
                        {PendingShipCount && PendingShipCount !== 0 ? (
                          <span
                            className="position-absolute badge rounded-pill bg-danger"
                            style={{
                              color: "white",
                              bottom: "20px",
                              marginLeft: "7px",
                            }}
                          >
                            {PendingShipCount}
                          </span>
                        ) : (
                          <></>
                        )}
                      </a>
                    </li>
                  ) : null} */}
                  {/*    {user == Role.mmpl ? (
                    <li className="nav-item nav-menu-item">
                      <a
                        onClick={(e) => this.PendingGrandAdminShipNavigation(e)}
                        className="nav-link discover navstyle"
                        href="/Home/GrandAdmin/PendingShipDetails"
                      >
                          Pending Ships {" "}
                        {t("TopPaneContent.PendingShips")}
                        {PendingShipCount && PendingShipCount !== 0 ? (
                          <span
                            className="position-absolute badge rounded-pill bg-danger"
                            style={{
                              color: "white",
                              bottom: "20px",
                              marginLeft: "7px",
                            }}
                          >
                            {PendingShipCount}
                          </span>
                        ) : (
                          <></>
                        )}
                      </a>
                    </li>
                  ) : null} */}

                  {user == Role.approver ? (
                    <li className="nav-item dropdown nav-menu-item">
                      <a
                        className="nav-link dropdown-toggle Approver-click discover navstyle"
                        href="#"
                        id="navbarDropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {" "}
                        {t("TopPaneContent.Approvals")}
                        {PendingShipCount && PendingShipCount !== 0 || ApprovalCount && ApprovalCount !== 0 ? (
                          <span
                            className="position-absolute badge rounded-pill bg-danger"
                            style={{
                              color: "white",
                              bottom: "20px",
                              marginLeft: "14px",
                              textAlign: "center",
                              marginBottom: "-5px"
                            }}
                          >
                            {ApprovalCount + PendingShipCount}
                          </span>)
                          : (
                            <></>
                          )}
                      </a>
                      <ul
                        className="dropdown-menu approver-dropdown"
                        aria-labelledby="navbarDropdownMenuLink"
                        style={{
                          transform: "translate3d(0px, 35px, 0px)",
                          position: "absolute",
                          willChange: "transform",
                          top: "0px",
                          left: "0px",
                        }}
                      >
                        <li>
                          <a className="dropdown-item"
                            onClick={(e) => this.PendingApproval(e)}
                            href="/Home/PendingApprovals"
                          >
                            {t("TopPaneContent.PendingApprovals")}
                            {ApprovalCount && ApprovalCount !== 0 ? (
                              <span
                                className="position-absolute badge rounded-pill bg-danger"
                                style={{
                                  color: "white",
                                  marginLeft: "2px",
                                  marginBottom: "-5px"
                                }}
                              >
                                {ApprovalCount}
                              </span>
                            ) : (
                              <></>
                            )}
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item"
                            onClick={(e) => this.PendingShipNavigation(e)}
                            href="/Home/PendingShip"
                          >
                            {t("TopPaneContent.PendingShips")}{" "}
                            {PendingShipCount &&
                              PendingShipCount !== 0 ? (
                              <span
                                className="position-absolute badge rounded-pill bg-danger"
                                style={{
                                  color: "white",
                                  bottom: "18px",
                                  marginLeft: "5px",
                                }}
                              >
                                {PendingShipCount}
                              </span>
                            ) : (
                              <></>
                            )}
                          </a>
                        </li>
                      </ul>
                    </li>
                  ) : null}
                  {window.location.href.indexOf("/Home/BudgetListView/:id") !==
                    -1 ? null : (
                    <>
                      {user == Role.mmpladmin ? (
                        <li className="nav-item dropdown nav-menu-item nav-cls-in">
                          <a
                            className="nav-link dropdown-toggle Admin-dropdown-click discover navstyle navigation_zone"
                            href="#"
                            id="navbarDropdownMenuLink"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
                            {" "}
                            {/* Admin */} {t("TopPaneContent.Admin")}
                          </a>
                          <ul
                            className="dropdown-menu admin-dropdown"
                            aria-labelledby="navbarDropdownMenuLink"
                            style={{
                              transform: "translate3d(0px, 35px, 0px)",
                              position: "absolute",
                              willChange: "transform",
                              top: "0px",
                              left: "0px",
                            }} >
                            <li className="dropdown-submenu">
                              <a
                                className="dropdown-item dropdown-toggle"
                                href="#"
                              >
                                {/*  Lookup */} {t("TopPaneContent.Lookup")}
                              </a>
                              <ul className="dropdown-menu">
                                <li
                                  onClick={(e) => this.LookUpNavigation(1, e)}
                                >
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Lookup/Interval#"
                                  >
                                    {/*   Interval */}{" "}
                                    {t("TopPaneContent.Interval")}
                                  </a>
                                </li>
                                <li
                                  onClick={(e) => this.LookUpNavigation(2, e)}
                                >
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Lookup/Category#"
                                  >
                                    {/*  Category */}{" "}
                                    {t("TopPaneContent.Category")}
                                  </a>
                                </li>
                                <li
                                  onClick={(e) => this.LookUpNavigation(3, e)}
                                >
                                  <a
                                    className="dropdown-item"
                                  /*href="/Home/ClassManagement" */
                                  >
                                    {/*  Class */} {t("TopPaneContent.ClassRegulation")}
                                  </a>
                                </li>
                                <li
                                  onClick={(e) => this.LookUpNavigation(4, e)}
                                >
                                  <a
                                    className="dropdown-item"
                                  /* href="/Home/LookupFlag" */
                                  >
                                    {/*  Flag */} {t("TopPaneContent.FlagRegulation")}
                                  </a>
                                </li>
                                <li
                                  onClick={(e) => this.LookUpNavigation(10, e)}
                                >
                                  <a
                                    className="dropdown-item"

                                  >
                                    {t("TopPaneContent.MISC")}
                                  </a>
                                </li>
                                <li
                                  onClick={(e) => this.LookUpNavigation(5, e)}
                                >
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Lookup/TypeofShip#"
                                  >
                                    {/*  Type of Ship */}{" "}
                                    {t("TopPaneContent.TypeofShip")}
                                  </a>
                                </li>

                                {/*  <li onClick={(e) => this.LookUpNavigation(5, e)}>
                              <a
                                className="dropdown-item"
                                href="/Home/Lookup/TypeofPort#"
                              >
                                Type of Port
                              </a>
                            </li> */}
                                <li
                                  onClick={(e) => this.LookUpNavigation(6, e)}
                                >
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Lookup/EquipmentType#"
                                  >
                                    {/*  Equipment Type */}{" "}
                                    {t("TopPaneContent.EquipmentType")}
                                  </a>
                                </li>

                                <li
                                  onClick={(e) => this.LookUpNavigation(7, e)}
                                >
                                  <a
                                    className="dropdown-item"
                                  /* href="/Home/LookupMakeAndModel" */
                                  >
                                    {/*  Make And Model */}{" "}
                                    {t("TopPaneContent.MakeAndModel")}
                                  </a>
                                </li>
                                <li
                                  onClick={(e) => this.LookUpNavigation(8, e)}
                                >
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Lookup/Unit#"
                                  >
                                    {/*  Unit */} {t("TopPaneContent.Unit")}
                                  </a>
                                </li>
                                {/* <li onClick={(e) => this.LookUpNavigation(9, e)}>
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Lookup/Zone#"
                                  >
                                    {t("TopPaneContent.Zone")}
                                  </a>
                                </li> */}
                              </ul>
                            </li>
                            <li
                              onClick={(e) => this.MasterScreenNavigation(1, e)}
                            >
                              <a
                                className="dropdown-item"
                                href="/Home/ShipManagement"
                              >
                                {/*  Ship Management */}{" "}
                                {t("TopPaneContent.ShipManagement")}
                              </a>
                            </li>
                            {/* <li onClick={() => this.MasterScreenNavigation(2)}><a className="dropdown-item" href="#">Client Management</a></li> */}
                            <li
                              onClick={(e) => this.MasterScreenNavigation(3, e)}
                            >
                              <a
                                className="dropdown-item"
                                href="/Home/Contracts"
                              >
                                {/* Contract Management */}{" "}
                                {t("TopPaneContent.ContractManagement")}
                              </a>
                            </li>
                            <li
                              onClick={(e) => this.MasterScreenNavigation(4, e)}
                            >
                              <a
                                className="dropdown-item"
                                href="/Home/EquipmentManagement"
                              >
                                {/* Equipment Management */}{" "}
                                {t("TopPaneContent.EquipmentManagement")}
                              </a>
                            </li>
                            <li
                              onClick={(e) => this.MasterScreenNavigation(12, e)}
                            >
                              <a
                                className="dropdown-item"
                                href="/Home/CostManagement"
                              >
                                {/* Equipment Management */}{" "}
                                {t("TopPaneContent.CostManagement")}
                              </a>
                            </li>
                            <li
                              onClick={(e) => this.MasterScreenNavigation(13, e)}
                            >
                              <a
                                className="dropdown-item"
                                href="/Home/AdhocAnalysis"
                              >
                                {/* Equipment Management */}{" "}
                                {t("TopPaneContent.AdhocAnalysis")}
                              </a>
                            </li>
                            <li
                              onClick={(e) => this.MasterScreenNavigation(7, e)}
                            >
                              <a
                                className="dropdown-item"
                                href="/Home/VendorManagement"
                              >
                                {/* Vendor Management */}{" "}
                                {t("TopPaneContent.VendorManagement")}
                              </a>
                            </li>
                            <li onClick={(e) => this.PendingShipNavigation(e)}>
                              <a
                                className="dropdown-item"
                                href="/Home/PendingShip"
                              >
                                {/* Pending Ships */}{" "}
                                {t("TopPaneContent.PendingShips")}
                              </a>
                              {/* <Link to="/Home/PendingShip" >PENDING</Link> */}
                            </li>
                            <li onClick={(e) => this.MasterScreenNavigation(11, e)}>
                              <a
                                className="dropdown-item"
                                href="/Home/InactiveShip"
                              >
                                {t("TopPaneContent.InactiveShips")}
                              </a>
                            </li>
                            <li
                              onClick={(e) => this.MasterScreenNavigation(5, e)}
                            >
                              <a className="dropdown-item" href="/Home/Port">
                                {/*   Port */} {t("TopPaneContent.Port")}
                              </a>
                            </li>
                            <li
                              onClick={(e) => this.MasterScreenNavigation(6, e)}
                            >
                              <a
                                className="dropdown-item"
                                href="/Home/ServicedBy"
                              >
                                {/*  Serviced By */}{" "}
                                {t("TopPaneContent.ServicedBy")}
                              </a>
                            </li>
                            {/* <li onClick={() => this.MasterScreenNavigation(7)}><a className="dropdown-item" href="#">Staff Management</a></li> */}

                            {user == Role.mmpladmin ? (
                              <li
                                onClick={(e) =>
                                  this.MasterScreenNavigation(9, e)
                                }
                              >
                                <a
                                  className="dropdown-item"
                                  href="/Home/ControlledDocuments"
                                >
                                  {/* Controlled Documents */}{" "}
                                  {t("TopPaneContent.ControlledDocuments")}
                                </a>
                              </li>
                            ) : (
                              <></>
                            )}
                            <li
                              onClick={(e) =>
                                this.MasterScreenNavigation(10, e)
                              }
                            >
                              {" "}
                              <a
                                className="dropdown-item"
                              /*  href="/Home/HistoryofActions" */
                              >
                                {/* History of Actions */}{" "}
                                {t("TopPaneContent.HistoryofActions")}
                              </a>
                            </li>
                            <li className="dropdown-submenu">
                              <a
                                className="dropdown-item dropdown-toggle"
                                href="#"
                              >
                                {/* User Management */}{" "}
                                {t("TopPaneContent.UserManagement")}
                              </a>
                              <ul className="dropdown-menu">
                                <li onClick={(e) => this.MMPLUserNavigation(e)}>
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Management/Users/MMPL"
                                  >
                                    {/*  MMPL */} {t("TopPaneContent.MMPL")}
                                  </a>
                                </li>
                                <li
                                  onClick={(e) => this.ClientUserNavigation(e)}
                                >
                                  <a
                                    className="dropdown-item"
                                  >
                                    {/* Client */} {t("TopPaneContent.Client")}
                                  </a>
                                </li>
                                <li
                                  onClick={(e) =>
                                    this.ClientContactUserNavigation(e)
                                  }
                                >
                                  <a className="dropdown-item">
                                    {t("TopPaneContent.ClientContacts")}
                                  </a>
                                </li>
                                <li onClick={(e) => this.ShipUserNavigation(e)}>
                                  <a
                                    className="dropdown-item"
                                    href="/Home/Management/Staff"
                                  >
                                    {/*  Ship Staff */}{" "}
                                    {t("TopPaneContent.ShipStaff")}
                                  </a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      ) : null}
                      {user !== Role.mmpladmin ? (
                        <li className="nav-item dropdown nav-menu-item">
                          <a
                            className="nav-link dropdown-toggle masterdata-click discover navstyle"
                            href="#"
                            id="navbarDropdownMenuLink"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {" "}
                            {t("TopPaneContent.MasterData")}
                            {user == Role.mmpl && PendingShipCount && PendingShipCount !== 0 ? (
                              <span
                                className="position-absolute badge rounded-pill bg-danger"
                                style={{
                                  color: "white",
                                  bottom: "13px",
                                  marginLeft: "6px"
                                }}>
                                {PendingShipCount}
                              </span>) : (<></>)}
                          </a>
                          <ul
                            className="dropdown-menu masterdata-dropdown"
                            aria-labelledby="navbarDropdownMenuLink"
                            style={{
                              transform: "translate3d(0px, 35px, 0px)",
                              position: "absolute",
                              willChange: "transform",
                              top: "0px",
                              left: "0px",
                            }}
                          >
                            <li
                              onClick={(e) => this.LookupotherNavigation(4, e)}
                            >
                              <a
                                className="dropdown-item pl-3"
                              /* href="/Home/LookupFlag" */
                              >
                                {/*  Flag */} {t("TopPaneContent.FlagRegulation")}
                              </a>
                            </li>
                            {user == Role.mmpl ? (
                              <li>
                                <a
                                  onClick={(e) =>
                                    this.PendingGrandAdminShipNavigation(e)
                                  }
                                  className="dropdown-item pl-3"
                                  href="/Home/GrandAdmin/PendingShipDetails"
                                >
                                  {t("TopPaneContent.PendingShips")}
                                  {PendingShipCount &&
                                    PendingShipCount !== 0 ? (
                                    <span
                                      className="position-absolute badge rounded-pill bg-danger"
                                      style={{
                                        color: "white",
                                        bottom: "15px",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {PendingShipCount}
                                    </span>
                                  ) : (
                                    <></>
                                  )}
                                </a>
                              </li>
                            ) : null}
                          </ul>
                        </li>
                      ) : null}

                      {user == Role.mmpl || user == Role.client ? (
                        <li onClick={(e) => this.MasterScreenNavigation(3, e)}
                          className="nav-item nav-menu-item">
                          <a
                            className="nav-link discover navstyle"
                          >
                            {/* Service Update */}
                            {t("TopPaneContent.ContractManagement")}
                          </a>
                        </li>
                      ) : null}
                    </>
                  )}
                  {/*   {user == Role.mmpladmin ? (
                     <i class="fa fa-exclamation-circle click"  onClick={(e) => this.PendingShipNavigation(e)} aria-hidden="true" style={{fontSize:"1.5rem",color:"red",marginTop:"16px"}}></i>
                  ):null} */}
                  {/* {user == Role.mmpl || user == Role.client ? (
                    <li onClick={(e) => this.MasterScreenNavigation(3, e)}
                      className="nav-item nav-menu-item">
                      <a
                        className="nav-link discover navstyle"
                      >
                        {t("TopPaneContent.ContractManagement")}
                      </a>
                    </li>
                  ) : null} */}

                </ul>
              </div>
            </nav>

            {/*   <div className="col-sm6 m-auto col-sm-2 p0 col-2 text-center">
              <div id="google_translate_element"></div>
            </div> */}
            {currentUser ? (
              <div className="ng-star-inserted h-menu col-3 text-right wrapper-lan-user">
                <div
                  className="p0 text-center multi"
                  style={{ marginTop: "9px" }}>
                  <select
                    id="Multi-language"
                    className="form-control"
                    onChange={this.changeLanguage}
                    value={this.state.selectedLanguage}
                  >
                    {" "}
                    <option value="en">English</option>
                    <option value="arab">Arabic</option>
                    <option value="zh">Chinese</option>
                    <option value="fr">French</option>
                    <option value="in">Indonesian</option>
                    <option value="ja">Japanese</option>
                    <option value="ko">Korean</option>
                    <option value="ma">Malay</option>
                    <option value="ru">Russian</option>
                    <option value="es">Spanish</option>
                  </select>
                </div>
                <div className="mt-2">
                  <UncontrolledDropdown>
                    <DropdownToggle nav caret>
                      {this.UserAvatar(currentUser)}
                      <span className="navstyle">
                        {currentUser.name.split("@")[0]}
                      </span>
                    </DropdownToggle>
                    <DropdownMenu right>
                      <h5 className="dropdown-item-text mb-0">
                        {currentUser.name.split("@")[0]}
                      </h5>
                      <p className="dropdown-item-text text-muted mb-0">
                        {currentUser.email}
                      </p>
                      <DropdownItem divider />
                      <DropdownItem onClick={() => this.changePassword()}>
                        {t("TopPaneContent.ChangePassword")}
                      </DropdownItem>
                      <DropdownItem onClick={() => this.logout()}>
                        {t("TopPaneContent.Sign Out")}
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
            ) : null}
          </div>
        </div>

        {this.state.show ? (
          <div
            className="collapse navbar-collapse show menu-item"
            id="main_nav"
          >
            <Menu
              onClick={this.handleClick}
              style={{ width: "100%", borderRight: "none", marginTop: "20px" }}
              defaultSelectedKeys={["1"]}
              // defaultOpenKeys={['sub1']}
              mode="inline"
            >
              <ul className="navbar-nav m-auto">
                {/* {ShowShipDetails ? (
                  <li className="nav-item nav-menu-item">
                    <Menu.Item key="M1" className="navstyle space mobile-menu mobile-menu">Ship Equipment Status</Menu.Item>
                  </li>
                ) : null} */}
                {user == Role.staff ? (
                  <li className="nav-item nav-menu-item">
                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu mobile-menu"
                      onClick={this.StaffDashboardNavigation}
                    >
                      {t("TopPaneContent.Home")}
                    </Menu.Item>
                  </li>
                ) : null}
                {user == Role.client ? (
                  <li className="nav-item nav-menu-item">
                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu mobile-menu"
                      onClick={this.ClientDashboardNavigation}
                    >
                      {t("TopPaneContent.Home")}
                    </Menu.Item>
                  </li>
                ) : null}
                {user == Role.mmpl || user == Role.mmpladmin ? (
                  <li className=" nav-menu-item">
                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu"
                      onClick={this.MMPLDashboardNavigation}
                    >
                      {t("TopPaneContent.Home")}
                    </Menu.Item>
                  </li>
                ) : null}

                {user == Role.mmpl || user == Role.mmpladmin ? (
                  <li className=" nav-menu-item">
                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu"
                      onClick={this.MMPLServiceUpdat}
                    >
                      {t("TopPaneContent.ServiceUpdate")}
                    </Menu.Item>
                  </li>
                ) : null}

                {user == Role.mmpl || user == Role.client ? (
                  <li className="nav-item nav-menu-item">
                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu"
                      onClick={(e) => this.MasterScreenNavigation(3, e)}
                    >
                      {t("TopPaneContent.ContractManagement")}
                    </Menu.Item>
                  </li>
                ) : null}
                {/*    {user == Role.approver ? (
                  <li className="nav-item nav-menu-item">
                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu"
                      onClick={this.PendingShipNavigation}
                    >
                      {t("TopPaneContent.PendingShips")}{" "}
                      {PendingShipCount && PendingShipCount !== 0 ? (
                        <span
                          className="position-absolute badge rounded-pill bg-danger"
                          style={{
                            color: "white",
                            bottom: "20px",
                            marginLeft: "7px",
                          }}
                        >
                          {PendingShipCount}
                        </span>
                      ) : (
                        <></>
                      )}
                    </Menu.Item>
                  </li>
                ) : null} */}
                {/*     {user == Role.mmpl ? (
                  <li className="nav-item nav-menu-item">
                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu"
                      onClick={this.PendingGrandAdminShipNavigation}
                    >
                      {/*  Pending Ships 
                      {t("TopPaneContent.PendingShips")}
                      {PendingShipCount && PendingShipCount !== 0 ? (
                        <span
                          className="position-absolute badge rounded-pill bg-danger"
                          style={{
                            color: "white",
                            bottom: "20px",
                            marginLeft: "7px",
                          }}
                        >
                          {PendingShipCount}
                        </span>
                      ) : (
                        <></>
                      )}
                    </Menu.Item>
                  </li>
                ) : null} */}

                {user == Role.approver ? (
                  <li className="nav-item nav-menu-item">
                    <Menu.Item
                      key="M1"
                      className="navstyle space mobile-menu"
                      onClick={this.PendingApproval}
                    >
                      {t("TopPaneContent.MyPendingApprovals")}{" "}
                      {/* My Pending Approvals */}
                      {ApprovalCount && ApprovalCount !== 0 ? (
                        <span
                          className="position-absolute badge rounded-pill bg-danger"
                          style={{ color: "white", bottom: "30px" }}
                        >
                          {ApprovalCount}
                        </span>
                      ) : (
                        <></>
                      )}
                    </Menu.Item>
                  </li>
                ) : null}

                {user == Role.mmpladmin ? (
                  <li className=" dropdown nav-menu-item">
                    <a
                      className="nav-link dropdown-toggle discover navstyle  navigation_zone"
                      style={{ paddingLeft: "24px", marginTop: "0.6rem" }}
                      href="#"
                      id="navbarDropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {" "}
                      {t("TopPaneContent.Admin")}{" "}
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdownMenuLink"
                    >
                      <li className="dropdown-submenu">
                        <a
                          className="nav-link dropdown-toggle discover navstyle mobile-menu mt-2"
                          // style={{ paddingLeft: "24px" }}
                          href="#"
                          id="navbarDropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {/* Lookup */} {t("TopPaneContent.Lookup")}
                        </a>
                        <ul className="dropdown-menu">
                          <li>
                            <Menu.Item
                              key="M2"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpIntervalNavigation}
                            >
                              {/*  Interval */}
                              {t("TopPaneContent.Interval")}
                            </Menu.Item>
                          </li>
                          <li>
                            <Menu.Item
                              key="M3"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpCategoryNavigation}
                            >
                              {/*   Category */} {t("TopPaneContent.Category")}
                            </Menu.Item>
                          </li>
                          <li>
                            <Menu.Item
                              key="M4"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpClassNavigation}
                            >
                              {/*  Class */} {t("TopPaneContent.ClassRegulation")}
                            </Menu.Item>
                          </li>
                          <li>
                            <Menu.Item
                              key="M5"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpFlagNavigation}
                            >
                              {/*  Flag */} {t("TopPaneContent.FlagRegulation")}
                            </Menu.Item>
                          </li>
                          <li>
                            <Menu.Item
                              key="M6"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpMiscNavigation}
                            >
                              {/* Type of Ship */}{" "}
                              {t("TopPaneContent.MISC")}
                            </Menu.Item>
                          </li>
                          <li>
                            <Menu.Item
                              key="M6"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpShipNavigation}
                            >
                              {/* Type of Ship */}{" "}
                              {t("TopPaneContent.TypeofShip")}
                            </Menu.Item>
                          </li>
                          {/*  <li>
                            <Menu.Item
                              key="M6"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpPortNavigation}
                            >
                              Type of Port
                            </Menu.Item>
                          </li> */}
                          <li>
                            <Menu.Item
                              key="M7"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpEquipmentNavigation}
                            >
                              {/*   Equipment Type */}
                              {t("TopPaneContent.EquipmentType")}
                            </Menu.Item>
                          </li>
                          <li>
                            <Menu.Item
                              key="M8"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpMakeModelNavigation}
                            >
                              {/*  Make And Model */}
                              {t("TopPaneContent.MakeAndModel")}
                            </Menu.Item>
                          </li>
                          <li>
                            <Menu.Item
                              key="M9"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpUnitNavigation}
                            >
                              {/*  Unit */} {t("TopPaneContent.Unit")}
                            </Menu.Item>
                          </li>
                          {/* <li>
                            <Menu.Item
                              key="M10"
                              className="navstyle space mobile-menu"
                              onClick={this.LookUpZoneNavigation}
                            >
                               {t("TopPaneContent.Zone")}
                            </Menu.Item>
                          </li> */}
                        </ul>
                      </li>
                      <li>
                        <Menu.Item
                          key="M1"
                          className="navstyle space mobile-menu"
                          onClick={this.MasterScreenShipNavigation}
                        >
                          {/* Ship Management */}{" "}
                          {t("TopPaneContent.ShipManagement")}
                        </Menu.Item>
                      </li>
                      {/* <li>
                        <Menu.Item
                          key="M2"
                          className="navstyle space mobile-menu"
                          onClick={this.MasterScreenClientNavigation}
                        >
                          {t("TopPaneContent.ClientManagement")}
                        </Menu.Item>
                      </li> */}

                      <li>
                        <Menu.Item
                          key="M3"
                          className="navstyle space mobile-menu"
                          onClick={this.MasterScreenContractNavigation}
                        >
                          {/*  Contract Management */}
                          {t("TopPaneContent.ContractManagement")}
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M4"
                          className="navstyle space mobile-menu"
                          onClick={this.MasterScreenEquipmentNavigation}
                        >
                          {/*  Equipment Management */}{" "}
                          {t("TopPaneContent.EquipmentManagement")}
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M2"
                          className="navstyle space mobile-menu"
                          onClick={this.MasterScreenCostNavigation}
                        >
                          {/*  Contract Management */}
                          {t("TopPaneContent.CostManagement")}
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M14"
                          className="navstyle space mobile-menu"
                          onClick={this.MasterScreenAdhoctNavigation}
                        >
                          {/*  Contract Management */}
                          {t("TopPaneContent.AdhocAnalysis")}
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M7"
                          className="navstyle space mobile-menu"
                          onClick={this.MasterScreenVendorNavigation}
                        >
                          {/*  Vendor Management */}{" "}
                          {t("TopPaneContent.VendorManagement")}
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M7"
                          className="navstyle space mobile-menu"
                          onClick={this.PendingShipNavigation}
                        >
                          {/* Pending Ships */}{" "}
                          {t("TopPaneContent.PendingShips")}
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M7"
                          className="navstyle space mobile-menu"
                          onClick={this.InactiveShipNavigation}
                        >{t("TopPaneContent.InactiveShips")}
                        </Menu.Item>
                      </li>

                      <li>
                        <Menu.Item
                          key="M5"
                          className="navstyle space mobile-menu"
                          onClick={this.MasterScreenPortNavigation}
                        >
                          {/*   Port */} {t("TopPaneContent.Port")}
                        </Menu.Item>
                      </li>
                      <li>
                        <Menu.Item
                          key="M6"
                          className="navstyle space mobile-menu"
                          onClick={this.MasterScreenServiceNavigation}
                        >
                          {/* Serviced By */} {t("TopPaneContent.ServicedBy")}{" "}
                        </Menu.Item>
                      </li>

                      {user == Role.mmpladmin ? (
                        <li>
                          <Menu.Item
                            key="M8"
                            className="navstyle space mobile-menu"
                            onClick={() => this.MasterScreenNavigation(9)}
                          >
                            {/*  Controlled Documents */}{" "}
                            {t("TopPaneContent.ControlledDocuments")}{" "}
                          </Menu.Item>
                        </li>
                      ) : (
                        <></>
                      )}
                      <li>
                        <Menu.Item
                          key="M10"
                          className="navstyle space mobile-menu"
                          onClick={() => this.MasterScreenNavigation(10)}
                        >
                          {/*  History of Actions */}{" "}
                          {t("TopPaneContent.HistoryofActions")}{" "}
                        </Menu.Item>
                      </li>
                      {/* <li>
                        <Menu.Item key="M7" className="navstyle space mobile-menu" onClick={this.MasterScreenUserNavigation}>User Management</Menu.Item>
                      </li> */}
                      <li className="dropdown-submenu">
                        <a
                          className="nav-link dropdown-toggle discover navstyle mobile-menu mt-2"
                          // style={{ paddingLeft: "24px" }}
                          href="#"
                          id="navbarDropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {/* User Management */}{" "}
                          {t("TopPaneContent.UserManagement")}
                        </a>
                        <ul className="dropdown-menu">
                          <li>
                            <Menu.Item
                              key="M2"
                              className="navstyle space mobile-menu"
                              onClick={() => this.MMPLUserNavigation()}
                            >
                              {t("TopPaneContent.MMPLUser")}
                            </Menu.Item>
                          </li>
                          <li>
                            <Menu.Item
                              key="M3"
                              className="navstyle space mobile-menu"
                              onClick={() => this.ClientUserNavigation()}
                            >
                              {t("TopPaneContent.ClientUser")}
                            </Menu.Item>
                          </li>
                          <li>
                            <Menu.Item
                              key="M5"
                              className="navstyle space mobile-menu"
                              onClick={() => this.ClientContactUserNavigation()}
                            >
                              {t("TopPaneContent.ClientContacts")}
                            </Menu.Item>
                          </li>
                          <li>
                            <Menu.Item
                              key="M4"
                              className="navstyle space mobile-menu"
                              onClick={() => this.ShipUserNavigation()}
                            >
                              {t("TopPaneContent.ShipUser")}
                            </Menu.Item>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                ) : null}
                {user !== Role.mmpladmin ? (
                  <li className="nav-item dropdown nav-menu-item">
                    <a
                      className="nav-link dropdown-toggle discover navstyle"
                      href="#"
                      style={{ paddingLeft: "24px" }}
                      id="navbarDropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {" "}
                      {t("TopPaneContent.MasterData")}
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdownMenuLink"
                    >
                      <li>
                        <Menu.Item
                          key="M1"
                          className="navstyle space mobile-menu"
                          onClick={this.LookUPMasterFlagNavigation}
                        >
                          {/*  Flag */} {t("TopPaneContent.FlagRegulation")}
                        </Menu.Item>
                      </li>
                      {user == Role.mmpl ? (
                        <li>
                          <Menu.Item
                            key="M2"
                            className="navstyle space mobile-menu"
                            onClick={this.PendingGrandAdminShipNavigation}
                          >
                            {/*  Pending Ships */}
                            {t("TopPaneContent.PendingShips")}
                            {PendingShipCount && PendingShipCount !== 0 ? (
                              <span
                                className="position-absolute badge rounded-pill bg-danger"
                                style={{
                                  color: "white",
                                  bottom: "10px",
                                  marginLeft: "7px",
                                }}
                              >
                                {PendingShipCount}
                              </span>
                            ) : (
                              <></>
                            )}
                          </Menu.Item>
                        </li>
                      ) : user == Role.approver ? (
                        <li>
                          <Menu.Item
                            key="M2"
                            className="navstyle space mobile-menu"
                            onClick={this.PendingShipNavigation}
                          >
                            {t("TopPaneContent.PendingShips")}{" "}
                            {PendingShipCount && PendingShipCount !== 0 ? (
                              <span
                                className="position-absolute badge rounded-pill bg-danger"
                                style={{
                                  color: "white",
                                  bottom: "10px",
                                  marginLeft: "7px",
                                }}
                              >
                                {PendingShipCount}
                              </span>
                            ) : (
                              <></>
                            )}
                          </Menu.Item>
                        </li>
                      ) : null}
                    </ul>
                  </li>
                ) : null}
              </ul>

              <Menu.Item
                key="M5"
                className="navstyle space"
                style={{ color: "#ae1916", textDecoration: "underline", paddingLeft: '0px', marginTop: '0.8rem' }}
                onClick={() => this.logout()}
              >
                {currentUser.name} {t("TopPaneContent.(SignOut)")}
              </Menu.Item>
              <Menu.Item
                key="M9"
                className="navstyle space"
                style={{ color: "#ae1916", textDecoration: "underline", paddingLeft: '0px' }}
                onClick={() => this.changePassword()}
              >
                {t("TopPaneContent.ChangePassword")}
              </Menu.Item>
            </Menu>
          </div>
        ) : null}
      </div>
    );
  }

  logout() {
    this.authService.logout();
  }

  changePassword = () => {
    this.props.history.push("/Home/ChangePassword");
    this.setState({ show: false });
  };

  UserAvatar(user) {
    return (
      <i
        className="fa fa-user-circle fa-lg rounded-circle align-self-center mr-2"
        style={{ width: "32px", display: "content" }}
      ></i>
    );
  }

  UserNavigation = () => {
    this.props.dispatch({ type: "User", data: false });
    this.props.history.push("/Home/Users");
  };
  LookupotherNavigation = () => {
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Flag" });
    this.props.history.push("/Home/MasterData/Flag");
    const newLocal = '.masterdata-dropdown';
    $(newLocal).removeClass('show');
    this.setState({ show: false });
  };

  LookUpNavigation = (id, e) => {

    
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    if (id === 1) {
      this.props.history.push("/Home/Lookup/Interval");
      this.props.dispatch({ type: "SubBannerTitle", data: "Interval" });
      const newLocal = '.admin-dropdown';
      $(newLocal).removeClass('show');

      // e.preventDefault();
    } else if (id === 2) {
      this.props.history.push("/Home/Lookup/Category");
      this.props.dispatch({ type: "SubBannerTitle", data: "Category" });
      // e.preventDefault();
    } else if (id === 3) {
      this.props.dispatch({ type: "classSearch", data: "" });
      this.props.history.push("/Home/LookupClass");
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({ type: "SubBannerTitle", data: "Class" });
      // e.preventDefault();
    } else if (id === 4) {
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({ type: "SubBannerTitle", data: "Flag" });
      this.props.dispatch({ type: "flagSearch", data: "" });
      this.props.history.push("/Home/LookupFlag");
      this.setState({ show: false });

      /*   e.preventDefault(); */
    } else if (id === 5) {
      this.props.history.push("/Home/Lookup/TypeofShip");
      this.props.dispatch({ type: "SubBannerTitle", data: "Type of Ship" });
      // e.preventDefault();
    } /* else if (id === 5) {
      this.props.history.push("/Home/Lookup/TypeofPort");
      this.props.dispatch({ type: "SubBannerTitle", data: "Type of Port" });
      // e.preventDefault();
    } */ else if (id === 6) {
      this.props.history.push("/Home/Lookup/EquipmentType");
      this.props.dispatch({ type: "SubBannerTitle", data: "Equipment Type" });
      // e.preventDefault();
    } else if (id === 7) {
      this.props.dispatch({ type: "makeModelSearch", data: "" });
      this.props.history.push("/Home/LookupMakeAndModel");
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({ type: "SubBannerTitle", data: "Make And Model" });
    } else if (id === 8) {
      this.props.history.push("/Home/Lookup/Unit");
      this.props.dispatch({ type: "SubBannerTitle", data: " Unit" });
    } else if (id === 9) {
      this.props.history.push("/Home/Lookup/Zone");
      this.props.dispatch({ type: "SubBannerTitle", data: "Zone" });
    }
    else if (id === 10) {
      this.props.dispatch({ type: "miscSearch", data: "" });
      this.props.history.push("/Home/LookupMisc");
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({ type: "SubBannerTitle", data: "MISC" });
    }

    // else if(id===8){
    //   this.props.history.push('/Home/Lookup/Responsibility')
    // }
    const newLocal = '.admin-dropdown';
    $(newLocal).removeClass('show');
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.setState({ show: false });
  };

  LookUpIntervalNavigation = () => {
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Interval" });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    this.props.history.push("/Home/Lookup/Interval");
    this.setState({ show: false });
  };

  LookUpCategoryNavigation = () => {
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Category" });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    this.props.history.push("/Home/Lookup/Category");
    this.setState({ show: false });
  };

  LookUpClassNavigation = () => {
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Class" });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    this.props.dispatch({ type: "classSearch", data: "" });
    this.props.history.push("/Home/LookupClass");
    this.setState({ show: false });
  };

  LookUpMiscNavigation = () => {
    this.props.history.push("/Home/LookupMisc");
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "MISC" });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.setState({ show: false });
  }

  LookUpFlagNavigation = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Flag" });
    this.props.dispatch({ type: "flagSearch", data: "" });
    this.props.history.push("/Home/LookupFlag");
    this.setState({ show: false });
  };
  LookUPMasterFlagNavigation = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Flag" });
    this.props.history.push("/Home/MasterData/Flag");
    this.setState({ show: false });
  };

  LookUpShipNavigation = () => {
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Type of Ship" });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    this.props.history.push("/Home/Lookup/TypeofShip");
    this.setState({ show: false });
  };

  /*   LookUpPortNavigation=()=>{
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Type of port" });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    this.props.history.push("/Home/Lookup/TypeofPort");
    this.setState({ show: false });
  } */

  LookUpEquipmentNavigation = () => {
    
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Equipment Type" });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    this.props.history.push("/Home/Lookup/EquipmentType");
    this.setState({ show: false });
  };
  LookUpMakeModelNavigation = () => {
    
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Make And Model" });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    this.props.history.push("/Home/LookupMakeAndModel");
    this.setState({ show: false });
  };

  LookUpUnitNavigation = () => {
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Unit" });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    this.props.history.push("/Home/Lookup/Unit");
    this.setState({ show: false });
  };
  LookUpZoneNavigation = () => {
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "LookupClear", data: true });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Zone" });
    this.props.dispatch({ type: "getLookupListSuccess", data: null });
    this.props.history.push("/Home/Lookup/Zone");
    this.setState({ show: false });
  };

  MasterScreenShipNavigation = () => {
    this.props.dispatch({ type: "ShipManagementsearchData", data: "" });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
    this.props.history.push("/Home/ShipManagement");
  };
  InactiveShipNavigation = () => {
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "InactiveShipsearchData", data: "" });
    this.props.history.push("/Home/InactiveShip");
  };
  MasterScreenVendorNavigation = () => {
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
    this.props.dispatch({ type: "vendorSearch", data: "" });
    this.props.history.push("/Home/VendorManagement");
  };

  MasterScreenClientNavigation = () => {
    this.props.dispatch({ type: "clientuserSearch", data: "" });
    this.props.history.push("/Home/ClientManagement");
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
  };

  MasterScreenContractNavigation = () => {
    this.props.history.push("/Home/Contracts");
    this.props.dispatch({ type: "contractSearch", data: "" });
    this.props.dispatch({ type: "Contracts", data: false });
    this.props.dispatch({ type: "ShowContractDetailsPane", data: false });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
  };

  MasterScreenCostNavigation = () => {
    this.props.history.push("/Home/CostManagement");
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
  }

  MasterScreenAdhoctNavigation = () => {
    this.props.history.push("/Home/AdhocAnalysis");
    this.props.dispatch({ type: "SubBannerTitle", data: "Adhoc Analysis" });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
  }

  MasterScreenEquipmentNavigation = () => {
    this.props.history.push("/Home/EquipmentManagement");
    this.props.dispatch({ type: "equipmentSearch", data: "" });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
  };

  MasterScreenPortNavigation = () => {
    this.props.dispatch({ type: "portSearch", data: "" });
    this.props.history.push("/Home/Port");
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
  };

  MasterScreenServiceNavigation = () => {
    this.props.history.push("/Home/ServicedBy");
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
  };

  MMPLUserNavigation = (e) => {
    this.props.dispatch({ type: "userSearch", data: "" });
    this.props.history.push("/Home/Management/Users/MMPL");
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "MMPL USER MANAGEMENT",
    });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.setState({ show: false });
    const newLocal = '.admin-dropdown';
    $(newLocal).removeClass('show');
    e.preventDefault();
  };

  ClientUserNavigation = (e) => {
    this.props.dispatch({ type: "clientuserSearch", data: "" });
    this.props.history.push("/Home/ClientManagement");
    this.props.dispatch({ type: "SubBannerTitle", data: "Client Management" });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.setState({ show: false });
    const newLocal = '.admin-dropdown';
    $(newLocal).removeClass('show');
    e.preventDefault();
  };

  ShipUserNavigation = (e) => {
    this.props.dispatch({ type: "staffSearch", data: "" });
    this.props.history.push("/Home/Management/Staff");
    this.props.dispatch({ type: "SubBannerTitle", data: "STAFF MANAGEMENT" });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.setState({ show: false });
    const newLocal = '.admin-dropdown';
    $(newLocal).removeClass('show');
    e.preventDefault();
  };

  ClientContactUserNavigation = (e) => {
    const { history, dispatch, t } = this.props;
    history.push("/Home/Management/Users/ClientContacts");
    dispatch({
      type: "SubBannerTitle",
      data: t("ClientContactUserManagementContent.Title").toUpperCase(),
    });
    dispatch({ type: "ShowRightPan", data: false });
    dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "ShowShipDetails", data: false });
    dispatch({ type: "EditEquipmentDetails", data: false });
    this.setState({ show: false });
    const newLocal = ".admin-dropdown";
    $(newLocal).removeClass("show");
    if (e) {
      e.preventDefault();
    }
  };

  MasterScreenNavigation = (id, e) => {
    if (id === 1) {
      this.props.history.push("/Home/ShipManagement");
      this.props.dispatch({ type: "SubBannerTitle", data: "Ship Management" });
      this.props.dispatch({ type: "ShipManagementsearchData", data: "" });
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      e.preventDefault();
    } else if (id === 2) {
      this.props.dispatch({
        type: "SubBannerTitle",
        data: "Client Management",
      });
      this.props.dispatch({ type: "clientuserSearch", data: "" });
      this.props.history.push("/Home/ClientManagement");
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      e.preventDefault();
    } else if (id === 3) {
      this.props.history.push("/Home/Contracts");
      this.props.dispatch({ type: "Contracts", data: false });
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({ type: "ShowContractDetailsPane", data: false });
      this.props.dispatch({
        type: "SubBannerTitle",
        data: "Contract Management",
      });
      this.props.dispatch({ type: "contractSearch", data: "" });
      e.preventDefault();
    } else if (id === 4) {
      this.props.history.push("/Home/EquipmentManagement");
      this.props.dispatch({ type: "equipmentSearch", data: "" });
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({
        type: "SubBannerTitle",
        data: "Equipment Management",
      });
      e.preventDefault();
    } else if (id === 12) {
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({ type: "SubBannerTitle", data: "Cost Management" });
      this.props.history.push("/Home/CostManagement");
      e.preventDefault();
    } else if (id === 5) {
      this.props.dispatch({ type: "portSearch", data: "" });
      this.props.history.push("/Home/Port");
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({ type: "SubBannerTitle", data: "Port" });
      e.preventDefault();
    } else if (id === 6) {
      this.props.history.push("/Home/ServicedBy");
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({ type: "SubBannerTitle", data: "Serviced By" });
      e.preventDefault();
    } /*  else if (id === 7) {
      this.props.history.push("/Home/Management/Staff");
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({ type: "SubBannerTitle", data: "Staff Management" });
      e.preventDefault();
    } */ else if (id === 7) {
      this.props.dispatch({ type: "vendorSearch", data: "" });
      this.props.history.push("/Home/VendorManagement");
      this.props.dispatch({
        type: "SubBannerTitle",
        data: "Vendor Management",
      });
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      e.preventDefault();
    } else if (id === 9) {
      this.props.dispatch({ type: "docSearch", data: "" });
      this.props.history.push("/Home/ControlledDocuments");
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({
        type: "SubBannerTitle",
        data: "Controlled Documents",
      });
      this.setState({ show: false });
      e.preventDefault();
    } else if (id === 10) {
      this.props.history.push("/Home/HistoryofActions");
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      this.props.dispatch({
        type: "SubBannerTitle",
        data: "History of Actions",
      });
      this.setState({ show: false });
      e.preventDefault();
    } else if (id === 11) {
      this.props.history.push("/Home/InactiveShip");
      this.props.dispatch({ type: "InactiveShipsearchData", data: "" });
      this.props.dispatch({ type: "SubBannerTitle", data: "Inactive Ships Dashboard" });
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      e.preventDefault();
    } else if (id === 13) {
      this.props.history.push("/Home/AdhocAnalysis");
      this.props.dispatch({ type: "SubBannerTitle", data: "Adhoc Analysis" });
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
      e.preventDefault();
    }
    const newLocal = '.admin-dropdown';
    $(newLocal).removeClass('show');
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.setState({ show: false });
  };

  MDShipmentNavigation = () => {
    this.props.dispatch({ type: "Shipment Library", data: false });
    this.props.dispatch({ type: "ShowRightPan", data: true });
    this.props.history.push("/Home");
    this.setState({ show: false });
  };

  StaffDashboardNavigation = (e) => {
    // this.props.dispatch({ type: "Client Dashboard", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
    this.props.dispatch({ type: "EditShipDetails", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    this.props.history.push("/Home/ShipDetails");
    this.setState({ show: false });
    e.preventDefault();
  };

  ClientDashboardNavigation = (e) => {
    this.props.dispatch({ type: "Client Dashboard", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
    this.props.dispatch({ type: "EditShipDetails", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    this.props.history.push("/Home/ClientDashboard");
    this.setState({ show: false });
    e.preventDefault();
  };

  MMPLDashboardNavigation = (e) => {
    const { t } = this.props;
    this.props.dispatch({ type: "MMPL Dashboard", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
    this.props.dispatch({ type: "EditShipDetails", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({
      type: "SubBannerTitle",
      data: `${this.props.t("content.Dashboard")}`,
    });
    this.props.history.push("/Home/MMPLDashboard");
    this.setState({ show: false });
    e.preventDefault();
  };

  MMPLServiceUpdat = (e) => {
    this.props.dispatch({ type: "serviceSearchData", data: this.state.SearchShips });
    this.props.dispatch({ type: "MMPL Dashboard", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
    this.props.dispatch({ type: "EditShipDetails", data: false });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Service Update" });
    this.props.history.push("/Home/ServiceUpdate");
    this.setState({ show: false });
    e.preventDefault();
  };

  ApproverDashboardNavigation = (e) => {
    this.props.history.push("/Home/ApproverDashboard");
    this.setState({ show: false });
    e.preventDefault();
  };

  PendingShipNavigation = (e) => {
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Pending Ship Dashboard",
    });
    this.props.dispatch({ type: "PendingsearchData", data: "" });
    this.props.history.push("/Home/PendingShip");
    this.setState({ show: false });
    const newLocal = '.admin-dropdown';
    $(newLocal).removeClass('show');
    const newLocal1 = '.approver-dropdown';
    $(newLocal1).removeClass('show');
    e.preventDefault();
  };
  PendingGrandAdminShipNavigation = (e) => {
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Pending Ship Dashboard",
    });
    this.props.history.push("/Home/GrandAdmin/PendingShipDetails");
    this.setState({ show: false });
    const newLocal = '.masterdata-dropdown';
    $(newLocal).removeClass('show');
    e.preventDefault();
  };

  PendingApproval = (e) => {
    this.props.history.push("/Home/PendingApprovals");
    this.setState({ show: false });
    e.preventDefault();
    const newLocal = '.approver-dropdown';
    $(newLocal).removeClass('show');
  };

  /*  MMPLHistoryAction = (e) => {
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "History of Actions",
    });
    this.props.history.push("/Home/HistoryofActions");
    e.preventDefault();
  };
 */
  Contracts = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({ type: "Contracts", data: false });
    this.props.dispatch({ type: "ShowRightPan", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
    this.props.dispatch({ type: "ShowContractDetailsPane", data: false });
    this.props.history.push("/Home/Contracts");
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.setState({ show: false });
  };
}

function mapStateToProps(state) {
  return {
    SubBannerTitle: state.SidePanReducer.SubBannerTitle || "MD Library",
    userDisplayName: state.SidePanReducer.userDisplayName,
    userDetail: state.SidePanReducer.userDetail,
    ApprovalCount: state.ApproverScreenReducer.ApprovalCount || null,
    PendingShipCount: state.ApproverScreenReducer.PendingShipCount || null,
    ShowShipDetails: state.SidePanReducer.ShowShipDetails || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MMTopPane))
);

/* export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MMTopPane)
); */
